/**
 * Sort Form - Custom element for sort dropdown (uses same structure as language picker)
 */
if (!customElements.get('sort-form')) {
  customElements.define(
    'sort-form',
    class SortForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="sort_by"]'),
          button: this.querySelector('.sort-form__button'),
          panel: this.querySelector('.sort-form__list-wrapper'),
        };

        if (!this.elements.button || !this.elements.panel || !this.elements.input) return;

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.closest('form');
        const value = event.currentTarget.dataset.value;
        const optionName = event.currentTarget.querySelector('span').textContent.trim();
        
        // Update hidden input
        this.elements.input.value = value;
        
        // Update button text
        this.elements.button.querySelector('span').textContent = optionName;
        
        // Update aria-current and check icons
        this.querySelectorAll('a').forEach((link) => {
          link.removeAttribute('aria-current');
          const checkIcon = link.querySelector('.sort-form__check-icon span');
          if (checkIcon) {
            checkIcon.classList.add('visibility-hidden');
            checkIcon.setAttribute('aria-hidden', 'true');
          }
        });
        
        event.currentTarget.setAttribute('aria-current', 'true');
        const currentCheckIcon = event.currentTarget.querySelector('.sort-form__check-icon span');
        if (currentCheckIcon) {
          currentCheckIcon.classList.remove('visibility-hidden');
          currentCheckIcon.removeAttribute('aria-hidden');
        }
        
        this.hidePanel();
        
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        if (
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }
    }
  );
}
